import { render, staticRenderFns } from "./TableColumnsDialog.vue?vue&type=template&id=412c4c4a"
import script from "./TableColumnsDialog.vue?vue&type=script&lang=js"
export * from "./TableColumnsDialog.vue?vue&type=script&lang=js"
import style0 from "./TableColumnsDialog.vue?vue&type=style&index=0&id=412c4c4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports